import axios from "../../lib/axiosInstance";

export function approveEngineerProfile(id) {
  return axios.get(`admin/approveProfile/${id}`).then((res) => res.data);
}

export function inviteEngineer(email) {
  return axios.post(`/admin/inviteEngineer`, { email }).then((res) => res.data);
}

export function fetchAllNewlyCreatedUsersByRole(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  if (params.fullName?.trim()) queryParams.append("fullName", params.fullName.trim());
  if (params.country) queryParams.append("country", params.country);
  if (params.city) queryParams.append("city", params.city);

  if (params.role) queryParams.append("role", params.role);
  if (params.email) queryParams.append("email", params.email);
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);

  if (params.status) queryParams.append("status", params.status);
  if (params.search?.trim()) queryParams.append("search", params.search.trim());
  if (params.excludeCompanyMembers) queryParams.append("excludeCompanyMembers", "true");
  if (params.excludeCompanyOwners) queryParams.append("excludeCompanyOwners", "true");

  const queryString = queryParams.toString();
  return axios.get(`admin/newUsers${queryString ? `?${queryString}` : ""}`).then((res) => res.data);
}

export function fetchCustomers(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.country) queryParams.append("country", params.country);
  if (params.city) queryParams.append("city", params.city);
  if (params.status) queryParams.append("status", params.status);
  if (params.customerName?.trim()) queryParams.append("customerName", params.customerName.trim());
  if (params.email?.trim()) queryParams.append("email", params.email.trim());
  if (params.search?.trim()) queryParams.append("search", params.search.trim());
  if (params.parentClientId) queryParams.append("parentClientId", params.parentClientId);
  if (params.sortBy) queryParams.append("sortBy", params.sortBy);
  if (params.sortOrder) queryParams.append("sortOrder", params.sortOrder);

  const queryString = queryParams.toString();
  return axios
    .get(`admin/customers${queryString ? `?${queryString}` : ""}`)
    .then((res) => res.data?.data);
}

export function fetchCustomerApprovalOptions(customerId) {
  return axios.get(`admin/customers/${customerId}/approvalOptions`).then((res) => res.data?.data);
}

export function approveCustomer({ id, branchId, teamId, secondaryTeamId }) {
  return axios
    .post(`admin/customers/${id}/approve`, { branchId, teamId, secondaryTeamId })
    .then((res) => res.data);
}

export function requestMissingDocuments(payload) {
  return axios.post("admin/request/resubmitMissingDocuments", payload).then((res) => res.data);
}

export function verifyOrUnverifyEngineerSkill(payload) {
  return axios.post("admin/skill/verify", payload).then((res) => res.data);
}

export function verifyOrUnverifyEngineerEquipment(payload) {
  return axios.post("admin/equipment/verify", payload).then((res) => res.data);
}

export function activateEngineer(id) {
  return axios.get(`admin/activateEngineer/${id}`).then((res) => res.data);
}

export function deactivateEngineer(id) {
  return axios.get(`admin/deactivateEngineer/${id}`).then((res) => res.data);
}
